import {
  appButtonBackground,
  appButtonFontColor,
  appButtonShadowColor,
  appButtonHoverColor,
  appButtonHoverBGColor,
} from 'globals/colors';

import { transitionDuration, transitionFunction } from 'globals/styles';

export default {
  wrapper: {
    pointerEvents: 'none',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: appButtonBackground,
    color: appButtonFontColor,
    fontSize: 14,
    fontWeight: 500,
    height: 48,
    boxShadow: `0 -8px 15px 0 ${appButtonShadowColor}`,
    textAlign: 'center',
    pointerEvents: 'all',
    cursor: 'pointer',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    margin: 5,
    ':hover': {
      color: appButtonHoverColor,
      backgroundColor: appButtonHoverBGColor,
    },
    ':active': {
      color: appButtonHoverColor,
      backgroundColor: appButtonHoverBGColor,
    },
  },
};
